import React from 'react';

import { Card, Text, Group, Title, Container, Stack } from '@mantine/core';
import { useLocalization } from 'context/localization-context';
import dayjs from 'dayjs';
import { AthleteAppointmentWithAthlete, AthleteKiloClassWithAthleteAndWaitlistOrder } from 'types';

const NotesView = ({
  athlete_kilo_classes_or_appointments,
}: {
  athlete_kilo_classes_or_appointments: (
    | AthleteKiloClassWithAthleteAndWaitlistOrder
    | AthleteAppointmentWithAthlete
  )[];
}): JSX.Element => {
  const { dateTimeFormat } = useLocalization();

  if (
    !athlete_kilo_classes_or_appointments.length ||
    athlete_kilo_classes_or_appointments.map(akc_or_aa => akc_or_aa.athlete.notes).flat().length === 0
  ) {
    return (
      <Group position='center'>
        <Text color='dimmed'>No notes to display</Text>
      </Group>
    );
  }
  return (
    <Container size='sm' p='0'>
      {athlete_kilo_classes_or_appointments.map(
        (
          athlete_kilo_class_or_appointment:
            | AthleteKiloClassWithAthleteAndWaitlistOrder
            | AthleteAppointmentWithAthlete,
          index: number,
        ) =>
          athlete_kilo_class_or_appointment.athlete.notes?.length ? (
            <Container key={index} mb='md'>
              <Title order={5}>{athlete_kilo_class_or_appointment.athlete.fullName}</Title>
              <Stack spacing='sm' mt='xs'>
                {athlete_kilo_class_or_appointment.athlete.notes.map((note, i) => (
                  <Card key={i} shadow='sm' radius='md' withBorder bg='#F3F3F3'>
                    <Group position='apart' mb='xs'>
                      <Text fw={700}>{note.title}</Text>
                      <Text size='sm'>{dayjs(note.createdAt).format(dateTimeFormat)}</Text>
                    </Group>
                    <Text
                      sx={{
                        wordBreak: 'break-word',
                        whiteSpace: 'break-spaces',
                      }}
                      lineClamp={5}
                      dangerouslySetInnerHTML={{ __html: note.content || '' }}
                    />
                  </Card>
                ))}
              </Stack>
            </Container>
          ) : (
            <></>
          ),
      )}
    </Container>
  );
};

export default NotesView;
